import { Divider, Grid } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import FlexView from 'react-flexview/lib'
import { SectionSpecialSelect } from '../../Core/Form/FormComponents'
import { MotorcycleCoveragesForm } from '../../Motorcycle/MotorcycleCoveragesForm'
import { SessionContextStore } from '../../../context/SessionContext'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { Action } from '../../../models/Action'
import { ContinueButton } from '../../Core/Buttons/ContinueButton'
import './CustomizePolicyRenewal.scss'
import {
  coveragesToIgnore,
  policyCoverageOrder,
  PolicyCoveragesMapping,
  policyCoverageThatUnderMotorcyclesOrder,
  nonRefundableCoverages,
} from '../../../models/insurance-models/CoveragesMapping'
import { ACTIONS, PolicyModificationContextStore } from '../../../context/PolicyModificationContext'
import { PolicyManagementContextStore } from '../../../context/PolicyManagementContext'

export const CoveragesModification = ({ onContinue }) => {
  const sessionContext = useContext(SessionContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const modifyContext = useContext(PolicyModificationContextStore)
  const myPoliciesContext = React.useContext(PolicyManagementContextStore)
  const onPolicyFieldChange = (name, value) => {
    let changed = { ...modifyContext.policy_coverages }
    changed[name] = value
    modifyContext.dispatch(
      new Action(ACTIONS.POLICY_COVERAGES_CHANGED, {
        newOffer: changed,
        isNewFlow: sessionContext.newPaymentFlow,
        administrativeDivision: sessionContext.user.administrativeDivision,
        options: offersContext.options,
      })
    )
  }

  const onDiminishingDeductibleChange = (motorcycleId, value) => {
    let changed = [...modifyContext.motorcycles_details]
    changed.filter(motor => motor.id == motorcycleId)[0].is_diminishing_deductible = value
    modifyContext.dispatch(new Action(ACTIONS.VEHICLE_COVERAGES_CHANGED, { newOffer: changed }))
  }

  const onMotorcycleChange = (motorcycleId, name, value) => {
    let changed = [...modifyContext.motorcycles_details]
    changed.filter(motor => motor.id == motorcycleId)[0].vehicle_coverages[name] = value
    modifyContext.dispatch(new Action(ACTIONS.VEHICLE_COVERAGES_CHANGED, { newOffer: changed }))
  }
  const handleContinue = () => {
    modifyContext.dispatch(new Action(ACTIONS.SAVE_COVERAGES))
    if (!modifyContext.isRenewal) {
      onContinue()
    }
  }

  useEffect(() => {
    modifyContext.validateCoverages()
  }, [])

  return (
    <>
      <Grid container spacing={4}>
        <FlexView vAlignContent="center" hAlignContent="left">
          <div className="text-body bold title-coverages">Policy Coverages</div>
        </FlexView>
        {Object.keys(modifyContext.policy_coverages).length > 0 &&
          policyCoverageOrder.map((covName, index) => {
            let coverageOptionId = modifyContext.policy_coverages[covName]
            let needToIgnore = false
            if (covName in coveragesToIgnore) {
              needToIgnore = coveragesToIgnore[covName].ignoreInCustomize
            }

            if (!needToIgnore && !!coverageOptionId) {
              return (
                <>
                  <SectionSpecialSelect
                    key={index}
                    onChange={onPolicyFieldChange}
                    name={covName}
                    errors={modifyContext.coveragesErrors['policy']}
                    warnings={Object.keys(modifyContext.coveragesErrors).length == 0 && modifyContext.coveragesToSign[covName]}
                    value={coverageOptionId}
                    buttons={offersContext.options[covName]}
                    title={PolicyCoveragesMapping[covName].title}
                    isPolicyManagment={true}
                  />
                  <div style={{ height: '10px', width: '100%' }}></div>
                </>
              )
            }
          })}
      </Grid>

      <Grid container spacing={4}>
        <Grid xs={12}>
          <FlexView vAlignContent="center" hAlignContent="left" className="margin-bottom-small">
            <div className="text-body bold title-coverages margin-top-7vh">Motorcycle Coverages</div>
          </FlexView>
        </Grid>
        {Object.keys(modifyContext.policy_coverages).length > 0 &&
          policyCoverageThatUnderMotorcyclesOrder.map(covName => {
            let coverageOptionId = modifyContext.policy_coverages[covName]
            let needToIgnore = false
            if (covName in coveragesToIgnore) {
              needToIgnore = coveragesToIgnore[covName].ignoreInCustomize
            }
            if (nonRefundableCoverages.includes(covName) && !modifyContext.isRenewal) {
              needToIgnore = true
            }
            if (!needToIgnore && !!coverageOptionId) {
              return (
                <>
                  <SectionSpecialSelect
                    onChange={onPolicyFieldChange}
                    name={covName}
                    errors={modifyContext.coveragesErrors['policy']}
                    warnings={Object.keys(modifyContext.coveragesErrors).length == 0 && modifyContext.coveragesToSign[covName]}
                    value={coverageOptionId}
                    buttons={offersContext.options[covName]}
                    title={PolicyCoveragesMapping[covName].title}
                    isPolicyManagment={true}
                  />
                  <div style={{ height: '10px', width: '100%' }}></div>
                  <Grid xs={12}>
                    <FlexView vAlignContent="center" hAlignContent="center">
                      <Divider variant="middle" style={{ width: '80%' }} />
                    </FlexView>
                  </Grid>
                </>
              )
            }
          })}

        {modifyContext.motorcycles_details.map((motorcycle, index) => {
          return (
            <>
              <div key={index} className="motorcycle-card">
                <Grid container spacing={2} alignItems={'center'} justifyContent={'space-between'}>
                  <Grid item xs={12} md={4}>
                    <div className="motrcycle-detailes">
                      <div className="text-small black margin-top-small">
                        <span className="bold">Make:</span> {motorcycle.make}
                      </div>
                      <div className="text-small black margin-top-small">
                        <span className="bold">Model:</span> {motorcycle.model}
                      </div>
                      <div className="text-small black margin-top-small">
                        <span className="bold">Year:</span> {motorcycle.year}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <FlexView hAlignContent="right">
                      <MotorcycleCoveragesForm
                        onChange={onMotorcycleChange}
                        onDiminishingDeductibleChange={onDiminishingDeductibleChange}
                        isNewFlow={sessionContext.newPaymentFlow}
                        isDiminishingDeductible={motorcycle.is_diminishing_deductible}
                        values={motorcycle.vehicle_coverages}
                        options={offersContext.options}
                        errors={modifyContext.coveragesErrors[motorcycle.id]}
                        motorcycleId={motorcycle.id}
                        needTooltip={false}
                        isPolicyManagment={true}
                        shouldHaveDivider={false}
                      />
                    </FlexView>
                  </Grid>
                </Grid>
              </div>
              <Grid item xs={12}>
                <FlexView vAlignContent="center" hAlignContent="center">
                  {modifyContext.motorcycles_details.length > 1 && modifyContext.motorcycles_details.length - 1 != index && (
                    <Divider variant="middle" style={{ width: '80%' }} />
                  )}
                </FlexView>
              </Grid>
            </>
          )
        })}
      </Grid>

      <FlexView className="margin-top-medium" vAlignContent="center" hAlignContent="left">
        <ContinueButton disabled={Object.keys(modifyContext.coveragesErrors).length > 0} label="Continue" onClick={handleContinue} />
      </FlexView>
    </>
  )
}
